var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm.downtimeObj?.GIDM?.downtimeStarted &&
      _vm.downtimeObj?.GIDM?.showWarning
        ? _c("downtime-alert", {
            attrs: { message: _vm.downtimeObj?.GIDM?.displayMsg },
          })
        : _vm._e(),
      _c(
        "detail-card",
        {
          attrs: {
            heading: _vm.isDesktopChannel
              ? _vm.props.MO.heading
              : _vm.props.heading,
            subheading: _vm.isDesktopChannel
              ? _vm.props.MO.subheading
              : _vm.props.subheading,
            imageType: !_vm.isDesktopChannel ? _vm.props.imageType : null,
            isLoading: _vm.isFetching,
            headingClass: _vm.isDesktopChannel
              ? "leo-text-left"
              : "leo-text-center",
          },
        },
        [
          _vm.isCredentialInvalid
            ? _c("leo-card-note", {
                staticStyle: { border: "1px solid #EB0033" },
                attrs: { color: "secondary", bgColor: "light-error" },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "icon",
                      fn: function () {
                        return [
                          _c("leo-icon", {
                            staticClass: "leo-mr-xs",
                            attrs: {
                              color: "error",
                              size: "lg",
                              type: "warning",
                            },
                          }),
                        ]
                      },
                      proxy: true,
                    },
                    {
                      key: "title",
                      fn: function () {
                        return [
                          _c("div", { staticClass: "leo-mb-xs" }, [
                            _vm._v(
                              " " +
                                _vm._s(_vm.props.MO.invalidCredentialHeading) +
                                " "
                            ),
                          ]),
                        ]
                      },
                      proxy: true,
                    },
                    {
                      key: "description",
                      fn: function () {
                        return [
                          _c("div", { staticClass: "leo-text-md" }, [
                            _vm._v(
                              " " +
                                _vm._s(_vm.props.MO.invalidCredentialLabel) +
                                " "
                            ),
                          ]),
                        ]
                      },
                      proxy: true,
                    },
                  ],
                  null,
                  false,
                  1774290044
                ),
              })
            : _vm._e(),
          _c(
            "leo-form",
            {
              ref: "form",
              on: {
                validate: function ($event) {
                  _vm.validated = $event
                },
              },
            },
            [
              _c(
                "form",
                {
                  attrs: {
                    autocorrect: "off",
                    role: "form",
                    spellcheck: "false",
                    autocapitalize: "off",
                    autocomplete: "new-password",
                  },
                  on: {
                    submit: function ($event) {
                      $event.preventDefault()
                      return _vm.submit.apply(null, arguments)
                    },
                  },
                },
                [
                  _c(
                    "div",
                    { staticClass: "leo-flex leo-flex-col leo-gap-md" },
                    [
                      _c("username-input", {
                        attrs: {
                          isError: _vm.isErrorUsername,
                          isDisabled:
                            _vm.isDisabledUserName || _vm.disableInput,
                          placeholderLabel: _vm.placeholderText,
                          autocomplete: "webauthn",
                          isPlaceholderRequired: !_vm.isDesktopChannel,
                        },
                        on: {
                          onBlur: function ($event) {
                            return _vm.validateSignInFormat(_vm.$v.username)
                          },
                        },
                      }),
                      _vm.isamMemberId !== ""
                        ? _c("leo-input", {
                            staticStyle: {
                              height: "0px",
                              opacity: "0",
                              padding: "0px",
                              "margin-top": "-1rem",
                            },
                            attrs: { disabled: true, id: "fake-user-input" },
                          })
                        : _vm._e(),
                      _c("PasswordInput", {
                        attrs: { isError: _vm.isErrorPassword },
                        on: {
                          onBlur: function ($event) {
                            return _vm.validateSignInFormat(_vm.$v.password)
                          },
                        },
                      }),
                      !_vm.isDisabledUserName
                        ? _c("div", [
                            _c(
                              "a",
                              {
                                class: [
                                  "leo-text-primary",
                                  "leo-link",
                                  "leo-cursor-pointer",
                                  !_vm.isDesktopChannel ? "leo-subheading" : "",
                                ],
                                on: { click: _vm.redirectToForgetPassword },
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.isDesktopChannel
                                        ? _vm.props.MO.resetPasswordLabel
                                        : _vm.props.forgotPasswordLabel
                                    ) +
                                    " "
                                ),
                              ]
                            ),
                          ])
                        : _vm._e(),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    {
                      class: [
                        "leo--flex",
                        "leo-flex-col",
                        _vm.isDesktopChannel ? "leo-pt-7xl" : "",
                      ],
                    },
                    [
                      _c(
                        "div",
                        [
                          _c(
                            "leo-button",
                            {
                              class: _vm.isDesktopChannel
                                ? "leo-mr-md"
                                : "leo-my-xl",
                              attrs: {
                                type: "submit",
                                primary: "",
                                block: "",
                                id: "btnSubmit",
                                disabled:
                                  _vm.downtimeObj?.GIDM?.disableButton ||
                                  !this.$v.username.$model ||
                                  this.$__isValidationError(this.$v.username) ||
                                  !this.$v.password.$model ||
                                  this.$__isValidationError(this.$v.password),
                              },
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.isDesktopChannel
                                      ? _vm.props.MO.buttonLabel
                                      : _vm.props.buttonLabel
                                  ) +
                                  " "
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                      !_vm.isDisabledUserName
                        ? _c(
                            "div",
                            {
                              class: [
                                "leo-flex leo-justify-center leo-text-center",
                                _vm.isDesktopChannel ? "leo-mt-xl" : "",
                              ],
                            },
                            [
                              _c("span", [
                                _vm._v(_vm._s(_vm.props.dontHaveLabel)),
                              ]),
                              _c(
                                "a",
                                {
                                  class: [
                                    "leo-text-primary leo-link leo-cursor-pointer",
                                    _vm.isDesktopChannel
                                      ? "leo-ml-2xs"
                                      : "leo-subheading leo-ml-xs",
                                  ],
                                  attrs: { href: "javascript:void(0);" },
                                  on: {
                                    click: function ($event) {
                                      _vm.isDesktopChannel
                                        ? _vm.openContactUs()
                                        : _vm.redirectToSignup()
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.isDesktopChannel
                                          ? _vm.props.MO.contactUsLabel
                                          : _vm.props.signupLinkLabel
                                      ) +
                                      " "
                                  ),
                                ]
                              ),
                            ]
                          )
                        : _vm._e(),
                    ]
                  ),
                ]
              ),
            ]
          ),
        ],
        1
      ),
      _c("contact-us", {
        attrs: { isShow: _vm.isContactUsShow },
        on: {
          "on-close": function ($event) {
            _vm.isContactUsShow = false
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }